export enum ERR_CODE {
  SUCCESS = '000000',
  ERROR_PROCESSING = '000001',
  PNUM_TELECOM_ERR = '030021',
  PNUM_JOINED_USER = '030002',
  PNUM_NOT_USER = '100012',
  CERT_OVER_THREE_TIME = '030007',
  CERT_WRONG_NUMBER_COUNT = '030008',
  CERT_NOT_SENDED = '030009',
  BLOCKED_MEMBER_ERROR = '030004',
  CERT_SUBIMT_TIME_ERROR = '030005',
  ERROR_COUPON = '030024',
  ERROR_NOT_ADULT = '030029',
  ERROR_RECAPTCHA = '100007',
  ERROR_CALL_SERVICE_CENTER = '030045',
  ERROR_USED_LIST_SERVICE_CENTER = '030046',
  SUCCESS_TODAY_REGISTERD = '030047',
  ERROR_WRONG_AUTHTOKEN = '030014',
  IN_REFUND_LIST = '100010',
  ERROR_AUTHTOKEN_LIMITED = '030016',
  REFUND_NEED_CANCEL = '100014',
  REFUND_CONTACT_CENTER = '100015',
  REFUND_CAPTCHA_COMPLETE = '103003',
  ERROR_RECAPTCHA_RESPONSE = '030001',
  ERROR_ALREADY_CAR_NUMBER = '030003',
  ERROR_IPHONE_USER = '030006',
  LOGIN_CERT_EXPIRED = '030010',
  LOGIN_INFO_EMPTY = '030011',
  ERROR_WRONG_PNUMBER = '030012',
  ERROR_WRONG_CAR_NUMBER = '030013',
  ERROR_INPUT_TIMEOUT = '030015',
  ERROR_NO_REQUEST_INFO = '030017',
  PNUM_JOINED_NOT_ADDITIONAL = '030018',
  ERROR_STICKER_REAPPLY = '030019',
  PNUM_ALREADY_ADDITIONAL = '030020',
  ERROR_SKT_ONLY = '030022',
  ERROR_TELECOM_JOIN = '030023',
  ERROR_PAYMENT = '030025',
  ERROR_PAYMENT_RETRY = '030026',
  ERROR_PAYLETTER = '030027',
  ERROR_PAYLETTER_PNUMBER = '030028',
  ERROR_TELECOM_CANCEL = '030030',
  ERROR_SKT_LGU_ONLY = '030031',
  ERROR_CHECK_TELECOM = '030032',
  ERROR_COUPON_ALREADY_USED = '030033',
  ERROR_SKT_KT_ONLY = '030034',
  ERROR_INVALID_PREFIX = '030035',
  ERROR_USER_NOT_FOUND = '030036',
  ERROR_ADDITIONAL_USER_NOT_FOUND = '030037',
  ERROR_STICKER_ALREADY_ISSUED = '030038',
  ERROR_TRY_AGAIN = '030039',
  ERROR_CALL_WITHIN_MINUTE = '100009',
  ERROR_SENT_WITHIN_THREE_MIN = '100011',
}
